import { Link } from "react-router-dom";
import * as Icons from "heroicons-react";
import Header from "../../Common/Header/Header";
import SideBar from "../../Common/SideBar/SideBar";
import { signInUser } from "../../Utility/Auth";
import { useSelector } from "react-redux";
import ReportSideBar from "../../Common/SideBar/ReportSideBar";
import DatePicker from "react-datepicker";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import WareHouseDW from "../../Common/CustomSelect/WareHouseDW";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useDateWiseSalesDueQuery } from "../../../services/reportsApi";
import { useWarehouseQuery } from "../../../services/warehouseApi";
const DateWiseSalesWithDueReport = () => {
  const auth = signInUser();
  const [warehouse, setWarehouse] = useState("allWh");

  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const { aamarId, storeSettings } = auth;
  const lang = useSelector((state) => state.languageReducer);

  const {
    data: sale,
    isLoading,
    isError,
    error,
  } = useDateWiseSalesDueQuery({
    startDate,
    endDate,
    warehouse,
    aamarId,
  });

  // console.log("sale", sale);

  // fine warehouse Name
  const [whName, setWhName] = useState("All Warehouses");

  const { data: wh, refetch } = useWarehouseQuery(warehouse);

  // Call refetch only if user?.warehouse changes
  useEffect(() => {
    if (warehouse) {
      refetch();
    }
  }, [warehouse, refetch]);

  // Update warehouse name when data changes
  useEffect(() => {
    if (wh?.name) {
      setWhName(wh.name); // Directly set the name, no need for optional chaining here
    }
  }, [wh]);

  // Export CSV
  const handleExportCSV = () => {
    if (!sale?.length) {
      alert("No data available for export.");
      return;
    }
    // Top Header value
    const options = { month: "numeric", day: "numeric", year: "numeric" };
    const formattedStart = new Date(startDate).toLocaleDateString(
      "en-US",
      options
    );
    const formattedEnd = new Date(endDate).toLocaleDateString("en-US", options);
    const generatedOn = new Date().toLocaleString();
    const generatedBy = auth?.name || "Aamar Dokan";
    const storeName =
      auth?.storeSettings?.storeName?.toUpperCase() || "Aamar Dokan";
    const warehouseName = whName;
    const reportTitle = "Date Wise Sales With Due Report";

    const headerInfo = [
      `,Store: ${storeName},,,,,Warehouse: ${warehouseName}`,
      `,Report: ${reportTitle},,,,,Date Range: ${formattedStart} to ${formattedEnd}`,
      `,Generated On: ${generatedOn},,,,Generated By: ${generatedBy}`,
      "",
      "",
    ];

    
    const csvTableHeader = [
      "S/N",
      "Invoice",
      "Date",
      "Customer",
      "Phone",
      "Warehouse",
      "Total Item",
      "Total",
      "Gross Total",
      // "Bill Type",
    ].join(",");

    let totalItems = 0;
    let totalAmount = 0;
    let totalGross = 0;

    const csvRows = sale.map((row, index) => {
      const items = Number(row?.totalItem || 0);
      const total = Number(row?.total || 0);
      const gross = Number(row?.grossTotal || 0);

      totalItems += items;
      totalAmount += total;
      totalGross += gross;

      return [
        index + 1,
        row?.invoice || "",
        new Date(row?.date).toLocaleDateString(),
        row?.customer || "",
        row?.phone || "",
        row?.warehouse || "",
        items,
        total.toFixed(2),
        gross.toFixed(2),
        // row?.billType || "",
      ].join(",");
    });

    const summaryLabelRow = [
      "",
      "",
      "",
      "",
      "",
      "",
      "** TOTAL SUMMARY **",
    ].join(",");

    const summaryHeaderRow = [
      "",
      "",
      "",
      "",
      "",
      "Total Items",
      "Total",
      "Gross Total",
    ].join(",");

    const summaryDataRow = [
      "",
      "",
      "",
      "",
      "",
      totalItems,
      totalAmount.toFixed(2),
      totalGross.toFixed(2),
    ].join(",");

    const csvContent = [
      ...headerInfo,
      csvTableHeader,
      ...csvRows,
      "",
      "",
      summaryLabelRow,
      summaryHeaderRow,
      summaryDataRow,
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "DateWiseSalesWithDueReport.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  // export PDF
  const handleExportPDF = () => {
    const doc = new jsPDF("landscape");
    if (!sale?.length) {
      alert("No data available for export.");
      return;
    }

    // Top Header value
    const options = { month: "numeric", day: "numeric", year: "numeric" };
    const formattedStart = new Date(startDate).toLocaleDateString(
      "en-US",
      options
    );
    const formattedEnd = new Date(endDate).toLocaleDateString("en-US", options);
    const reportGeneratedAt = new Date().toLocaleString();
    const storeName =
      auth?.storeSettings?.storeName?.toUpperCase() || "Aamar Dokan";
    const warehouseName = whName;
    const reportName = "Date Wise Sales With Due Report";

    // Title
    doc.setFontSize(16);
    doc.text(storeName, 140, 15, { align: "center" });

    doc.setFontSize(12);
    doc.text(reportName, 140, 22, { align: "center" });

    // Header info - Justify between
    doc.setFontSize(10);
    doc.text(`Store: ${storeName}`, 14, 28);
    doc.text(`Warehouse: ${warehouseName}`, 14, 33);
    doc.text(`Date: ${formattedStart} - ${formattedEnd}`, 14, 39);
    doc.text(`Generated By: ${auth?.name}`, 280, 28, { align: "right" });
    doc.text(`${reportGeneratedAt}`, 280, 33, { align: "right" });

    // === Sales Table Headers ===
    const headers = [
      [
        "S/N",
        "Invoice",
        "Date",
        "Customer",
        "Phone",
        "Warehouse",
        "Total Items",
        "Total",
        "Gross Total",
        "Bill Type",
      ],
    ];

    const body = sale.map((item, index) => [
      index + 1,
      item.invoice || "N/A",
      new Date(item.date).toLocaleDateString() || "N/A",
      item.customer || "N/A",
      item.phone || "N/A",
      item.warehouse || "N/A",
      item.totalItem || 0,
      item.total || 0,
      item.grossTotal || 0,
      item.billType === "due" ? "Due Bill" : "",
    ]);

    // === Sales Table ===
    autoTable(doc, {
      head: headers,
      body: body,
      startY: 45,
      theme: "grid",
      styles: {
        fontSize: 9,
        halign: "center",
      },
      headStyles: {
        fillColor: [242, 101, 45],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
    });

    // === Summary Section ===
    const finalY = doc.lastAutoTable.finalY + 10;
    const boxWidth = 80;
    const pageWidth = doc.internal.pageSize.getWidth();
    const boxX = pageWidth - boxWidth - 15;
    const boxY = finalY;

    doc.setLineDashPattern([1, 1], 0);
    doc.rect(boxX, boxY, boxWidth, 30);
    doc.setLineDashPattern([], 0);

    const labelX = boxX + 5;
    const valueX = boxX + boxWidth - 5;
    let y = boxY + 10;

    doc.setFontSize(9);

    doc.text("Gross Total:", labelX, y);
    doc.text(`${sumField(sale, "grossTotal")}`, valueX, y, { align: "right" });

    y += 6;
    doc.text("Total Items:", labelX, y);
    doc.text(`${sumField(sale, "totalItem")}`, valueX, y, { align: "right" });

    y += 6;
    doc.text("Total Due:", labelX, y);
    doc.text(`${sumField(sale, "total")}`, valueX, y, { align: "right" });

    // Save the PDF
    doc.save("DateWiseSalesWithDueReport.pdf");
  };

  // === Utility Function ===
  const sumField = (data, field) =>
    data
      .reduce((acc, item) => acc + (parseFloat(item[field]) || 0), 0)
      .toFixed(2);

  //warehouse
  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
  };

  return (
    <div>
      <div>
        <h2 className="mb-3">
          <Icons.ShoppingCartOutline size={35} /> Date Wise Sales With Due Report
        </h2>
      </div>

      <div
        className="mt-3 w-40 p-3"
        style={{ backgroundColor: "#f1f3f5", borderRadius: "8px" }}
      >
        <div className=" d-flex mt-2 mb-2 align-items-center justify-content-center gap-2">
          <DatePicker
            selected={new Date(startDate)}
            className="form-control w-100"
            onChange={(date) =>
              setStartDate(format(new Date(date), "MM-dd-yyyy"))
            }
          />
          <DatePicker
            selected={new Date(endDate)}
            className="form-control me-4"
            onChange={(date) =>
              setEndDate(format(new Date(date), "MM-dd-yyyy"))
            }
          />
        </div>

        <div className="">
          {auth?.type === "admin" && (
            <div className="my-3">
              <WareHouseDW
                id="warehouse"
                name="warehouse"
                handleOnChange={handleOnchangeWareHouseFrom}
                className="form-control"
              />
            </div>
          )}
        </div>

        <div className="d-flex gap-3 justify-content-center align-items-center text-center">
          {/* Download CSV Button */}
          <button
            className="btn btn-dark w-100 mt-3"
            style={{ borderRadius: "5px" }}
            onClick={handleExportCSV}
          >
            <Icons.DownloadOutline size={22} /> Download CSV
          </button>

          {/* Download PDF Button */}
          <button
            className="btn btn-dark w-100 mt-3"
            style={{ borderRadius: "5px" }}
            onClick={handleExportPDF}
          >
            <Icons.DocumentOutline size={22} /> Download PDF
          </button>
        </div>
      </div>
    </div>
  );
};

export default DateWiseSalesWithDueReport;
